exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.iconLeft[data-v-c0a2625c] {\n    margin-right: 3px;\n    margin-top: -4px;\n}\n.medium[data-v-c0a2625c] {\n    font-size: 18px !important;\n}\n\n", ""]);
